import { ChangeDetectionStrategy, Component, inject, model, Signal, signal,} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ToastrService } from '../../../shared/services/toastr-service';
import { VehiculeService } from '../../service/vehicule-service';
import { HttpClient } from '@angular/common/http';
import { Assure, GarantieI, Vehicule } from '../../../shared/model';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatCheckbox } from "@angular/material/checkbox";
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { DateMaskDirective } from '../../../shared/Directive/DateMask';
import { MatIcon } from '@angular/material/icon';

export interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Vehicule,
  assurance ?: any,
  assure ?: Assure,
  garanties ?:GarantieI[]
}


export interface VehiculeInFos{
  marques : MarqueI[]
}

interface MarqueI{
    name_marque : string,
    region : string,
    type : string,
    vin_group : string,
    vin_prefix : string[],
    models : string[]
}

@Component({
  selector: 'app-vehicule-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatSpinner,
    MatSlideToggle,
    DateMaskDirective,
    MatIcon
],
  templateUrl: '../modal/modal-vehicule.html',
  styleUrl: '../modal/modal-vehicule.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehiculeComponentModal {
  readonly dialogRef = inject(MatDialogRef<VehiculeComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  readonly assure = model(this.inputData.data!);

  vehiculeForm : FormGroup = new FormGroup({})

  marques = signal<MarqueI[]>([])
  models = signal<string[]>([])
  vehiculeInfos !: VehiculeInFos

  energies : string[] = ["ESSENCE", "DIESEL"]

  readonly dialog = inject(MatDialog);
  loadingbtn = signal<boolean>(false)

  genres : string[] = ['VP', 'TOURISME', 'CAMIONNETTE', 'FOURGON',
                      'PICKUP', 'CAMION', 'PLATEAU',
                      'TRACTEUR', 'MOTOCYCLETTE', 'TRICYCLE', 'GARAGE', 'AUTO-ECOLE',
                      'CORBILLARD', 'FOURGON FUNEBRE', 'REMORQUE']
  genresFiltered : string[] = []

  constructor(
    private fb : FormBuilder,
    private vehiculeService : VehiculeService,
    private toastr : ToastrService,
    private http : HttpClient
  ){

    this.genresFiltered = this.genres.slice()
  }

  ngOnInit(): void {
    this.loadVehiculesInfos()

    if(this.inputData.data?.remorque){
      this.vehiculeForm = this.fb.group({
        immatriculation : ['', [Validators.required]],
        chassis : ['', [Validators.required]],
        marque : ['', [Validators.required]],
        model : ['', [Validators.required]],
        puissance : [0],
        cylindree : [0],
        genre : ['', [Validators.required]],
        energie : [''],
        date_circulation : [''],
        place : [0] ,
        charge_utile : [0],
        charge_vide : [0],
        remorque : false
      })
    }else{
      this.vehiculeForm = this.fb.group({
        immatriculation : ['', [Validators.required]],
        chassis : ['', [Validators.required]],
        marque : ['', [Validators.required]],
        model : ['', [Validators.required]],
        puissance : [0, [Validators.required, Validators.min(1)]],
        cylindree : [0],
        genre : ['', [Validators.required]],
        energie : ['', [Validators.required]],
        date_circulation : [''],
        place : [0, [Validators.required, Validators.min(1)]] ,
        charge_utile : [0],
        charge_vide : [0],
        remorque : false
      })
    }
  }

  ngAfterViewInit(): void {
    this.vehiculeForm.patchValue(this.inputData?.data!)

    this.vehiculeForm.get('chassis')?.valueChanges.subscribe((chassis : string) =>{
      if(chassis != "")
        this.marques.update(val => this.vehiculeInfos.marques.filter((item) => chassis.toLowerCase().includes(item.vin_group.toLowerCase())))
      else
        this.marques.update(val => this.vehiculeInfos.marques)
    })

    //filter marques
    this.vehiculeForm.get('marque')?.valueChanges.subscribe((val : string) =>{
      if(val!=""){
        const valueFilter = val.toLowerCase().trim()
        const dataFiltered = this.vehiculeInfos.marques.filter(item => item.name_marque.toLowerCase().includes(valueFilter))
        this.marques.update(val => dataFiltered)
      }else{
        this.marques.update(val => this.vehiculeInfos.marques)
        this.models.update(val => [])
      }

    })

    //filter models
    this.vehiculeForm.get('model')?.valueChanges.subscribe((val : string) =>{
      if(val!=""){
        const valueFilter = val.toLowerCase().trim()
        const dataFiltered = this.models().filter(item => item.toLowerCase().includes(valueFilter))
        this.models.update(val => dataFiltered)
      }else{
        this.loadModel(this.vehiculeForm.get('marque')?.value)
      }

    })

    this.vehiculeForm.get('remorque')?.valueChanges.subscribe((res : boolean) =>{
      if(res){
        this.vehiculeForm.get('place')?.setValue(0)
        this.vehiculeForm.get('puissance')?.setValue(0)
        this.vehiculeForm.get('cylindree')?.setValue(0)
        this.vehiculeForm.get('energie')?.setValue('')

        this.vehiculeForm.get('place')?.setErrors(null)
        this.vehiculeForm.get('puissance')?.setErrors(null)
        this.vehiculeForm.get('energie')?.setErrors(null)
      }else{
        this.vehiculeForm.get('energie')?.setErrors(Validators.required)
        this.vehiculeForm.get('place')?.setErrors(Validators.min(1))
        this.vehiculeForm.get('place')?.setValue(5)
        this.vehiculeForm.get('puissance')?.setErrors(Validators.min(1))
      }
    })

    //filtrer les genres
    this.vehiculeForm.get('genre')?.valueChanges.subscribe((val : string) =>{
      if(val!=""){
        const valueFilter = val.toLowerCase().trim()
        this.genresFiltered = this.genres.filter(item => item.toLowerCase().includes(valueFilter))
      }else{
        this.genresFiltered = this.genres.slice()
      }

    })
  }

  loadVehiculesInfos(){
    this.http.get<VehiculeInFos>('marques_vehicules_monde.json').subscribe((res) =>{
      this.vehiculeInfos = res
      this.marques.update(val => this.vehiculeInfos.marques)
    })
  }

  loadModel(marque : string){
    if(marque == undefined || marque == null || marque == '')
      return;

    this.models.update(val => this.vehiculeInfos.marques.filter((item) => item.name_marque.toLowerCase() == marque.toLowerCase().trim())[0]?.models)
  }

  resetForm(){
    this.vehiculeForm.patchValue({
      immatriculation : '',
      chassis : '',
      marque : '',
      model : '',
      puissance : 0,
      cylindree : 0,
      genre : '',
      energie : '',
      date_circulation : [''],
      place : 5 ,
      charge_utile : 0,
      charge_vide : 0,
      remaorque : false
    })
    this.vehiculeForm.markAsUntouched()
  }


  onAdd(){
    this.loadingbtn.update(val => true)
    const data = this.vehiculeForm.value
    data['assure_id'] = this.inputData?.assure?.id
    this.vehiculeService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
        this.loadingbtn.update(val => false)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
         this.loadingbtn.update(val => false)
      },
    })
  }

  onUpdate(){
    this.loadingbtn.update(val => true)
    const data = this.vehiculeForm.value;
    data['assure_id'] = this.inputData.data?.assure_id
    console.log(this.inputData);

    this.vehiculeService.update(data, this.inputData.data?.id!).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
        this.loadingbtn.update(val => false)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
         this.loadingbtn.update(val => false)
      },
    })
  }

  checkValue(key : string, value : string, fromName : string){
    if(value == '')
      return;

    this.vehiculeService.checkValues(key, value.trim().replaceAll(" ", ""))
    .then((res) =>{
      if(res)
        this.vehiculeForm?.get(fromName)?.setErrors({'exist' : true})
      else
        this.vehiculeForm?.get(fromName)?.setErrors(null)
    })
  }

}
